// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4cf2fc82","455":"07995f9f","977":"c76e954f"}[chunkId] + ".chunk.js";
};